import React, { useState } from "react";

import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  Slide,
  Typography,
  IconButton
} from "@mui/material";
import { Close } from "@mui/icons-material"; 
import { TransitionProps } from "@mui/material/transitions";

import { useDispatch } from "react-redux";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface i_userformat {
  show: boolean;
  cancel: any;
  confirm: any;
}

const ConfirmDeleteModal = ({ show, cancel, confirm }: i_userformat) => {

  return (
    <Dialog
      open={show}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => cancel()}
      aria-describedby="alert-dialog-slide-description"
      maxWidth={"sm"}
    >
      <IconButton
        aria-label="close"
        onClick={() => cancel()}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
      
        }}
      >
        <Close sx={{color : "gray"}} />
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        <Grid container direction="column">
          <Typography
            align="center"
            fontSize={18}
            sx={{
              mb: 3
            }}
            color="primary"
          >
            Are you sure you want to delete this item?
          </Typography>
          <Grid
            direction="row"
            container
            spacing={2}
            sx={{
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Grid item>
              <Button
                data-testid="yes"
                variant="contained"
                color="primary"
                onClick={confirm}
                sx={{ padding: "4px 10px" }}
              >
                Yes
              </Button>
            </Grid>
            <Grid item>
              <Button color="primary"
                variant="outlined"
                onClick={() => cancel()}
                sx={{ padding: "4px 10px" }}
              >
                No
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
